import './ProgressBar.scss';

interface ProgressBarProps {
  value: number;
  max: number;
  /** Shown on hover through the app's shared tooltip. */
  tooltip?: string;
  style?: React.CSSProperties;
}

export function ProgressBar({ value, max, tooltip, style }: ProgressBarProps) {
  return (
    <progress
      className="progress-bar"
      value={value}
      max={max}
      style={style}
      data-tooltip-id={tooltip ? 'main-tooltip' : undefined}
      data-tooltip-content={tooltip}
    />
  );
}
